module.exports = __webpack_public_path__ + "img/_old_banner-principal@2x.eaf2616a.png";